/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React Base Styles
import colors from '../../colors';
import typography from '../../typography';
import boxShadows from '../../boxShadows';

// Soft UI Dashboard PRO React Helper Functions
import pxToRem from '../../../functions/pxToRem';

const { white, body, info, secondary, light } = colors;
const { size, fontWeightBold } = typography;
const { buttonBoxShadow } = boxShadows;

export default {
    base: {
        backgroundColor: white.main,
        minHeight: pxToRem(40),
        color: body.main,
        boxShadow: buttonBoxShadow.main,
        padding: `${pxToRem(12)} ${pxToRem(24)}`,

        '&:hover': {
            backgroundColor: white.main,
            boxShadow: buttonBoxShadow.stateOf,
        },

        '&:focus': {
            boxShadow: buttonBoxShadow.stateOf,
        },

        '&:active, &:active:focus, &:active:hover': {
            opacity: 0.85,
            boxShadow: buttonBoxShadow.stateOf,
        },

        '&:disabled': {
            backgroundColor: light.main,
            boxShadow: 'none',
        },

        '& .material-icon, .material-icons-round, svg:not(.custom-size)': {
            fontSize: `${pxToRem(20)} !important`,
        },
    },

    small: {
        minHeight: pxToRem(32),
        padding: `${pxToRem(8)} ${pxToRem(16)}`,
        fontSize: size.xs,
        lineHeight: pxToRem(16),
        fontWeight: fontWeightBold,

        '& .material-icon, .material-icons-round, svg:not(.custom-size)': {
            fontSize: `${pxToRem(16)} !important`,
        },
    },

    large: {
        minHeight: pxToRem(47),
        padding: `${pxToRem(14)} ${pxToRem(40)}`,
        fontSize: size.xl,

        '& .material-icon, .material-icons-round, svg:not(.custom-size)': {
            fontSize: `${pxToRem(24)} !important`,
        },
    },

    primary: {
        backgroundColor: info.main,

        '&:hover': {
            backgroundColor: info.main,
        },

        // '&:focus:not(:hover)': {
        //     backgroundColor: info.focus,
        //     boxShadow: buttonBoxShadow.stateOfNotHover,
        // },
    },

    secondary: {
        backgroundColor: secondary.main,

        '&:hover': {
            backgroundColor: secondary.main,
        },

        '&:focus:not(:hover)': {
            backgroundColor: secondary.focus,
            boxShadow: buttonBoxShadow.stateOfNotHover,
        },
    },
};
